class TaggingEnvironment {
    constructor() {
        this.liveContentfulTag = process.env.GATSBY_CONTENTFUL_TAG;
        this.stagingContentfulTag = process.env.GATSBY_CONTENTFUL_TAG + " - Staging";
        this.environments = {};

        if(process.env.GATSBY_ACTIVE_ENV === "live") {
            this.environments.prodEnvironment = this.liveContentfulTag;
            this.environments.stagingEnvironment = "";
        } else {
            this.environments.prodEnvironment = this.liveContentfulTag;
            this.environments.stagingEnvironment = this.stagingContentfulTag;
        }

        this.checkEnvironment = this.checkEnvironment.bind(this);
    }

    checkEnvironment(tags) {

        const isStagingEnv = this.environments.stagingEnvironment === this.stagingContentfulTag

        const hasStaging = tags.some(e => e.name === this.stagingContentfulTag)

        const hasLive = tags.some(e => e.name === this.liveContentfulTag)

        if(isStagingEnv){
            //On staging
            if(hasStaging) {
                //Has staging tag
                return true;
            }else if(hasLive) {
                //Has live tag
                return true;
            }
        }else{
            //On live
            if(hasLive) {
                //Has live tag
                return true;
            }else if(hasStaging) {
                //Has staging tag
                return false;
            }
        }
        return false;
    }
}

module.exports = new TaggingEnvironment();